import { render, staticRenderFns } from "./PaymentExpired.vue?vue&type=template&id=76da3460&scoped=true&"
import script from "./PaymentExpired.vue?vue&type=script&lang=js&"
export * from "./PaymentExpired.vue?vue&type=script&lang=js&"
import style0 from "./PaymentExpired.vue?vue&type=style&index=0&id=76da3460&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76da3460",
  null
  
)

export default component.exports